import type { EstadoDoArtigo } from '@titularis/api-client';

/**
 * Como cada estado do ciclo (D-43) aparece na tela.
 *
 * **Num lugar só** porque três telas os mostram - o backlog, o inventário e a
 * lei artigo a artigo -, e três cópias divergiriam no primeiro estado novo: a
 * mesma linha apareceria como "A revisar" numa e como `sugerido` na outra.
 */
export const ROTULO: Record<EstadoDoArtigo, { texto: string; cor?: string }> = {
  pendente: { texto: 'Pedido' },
  reivindicado: { texto: 'Com um motor', cor: 'processing' },
  sugerido: { texto: 'A revisar', cor: 'warning' },
  publicado: { texto: 'No ar', cor: 'success' },
  devolvido: { texto: 'Devolvido', cor: 'error' },
};

export const rotuloDoEstado = (estado: EstadoDoArtigo) => ROTULO[estado].texto;
